























import { PersonLabelEnum } from "@/lib/enum/person-label.enum";
import { phoneRule } from "@/lib/rules/contactRule";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IPersonPhone } from "@/models/person-phone.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import Debug from "../utility/Debug.vue";

@Component({
  components: { Debug },
  filters: {}
})
export default class PersonPhoneForm extends mixins(RulesMixin) {
  readonly PersonLabelEnum = PersonLabelEnum;

  @Prop()
  value!: IPersonPhone;

  get phoneRule() {
    return [phoneRule()];
  }
}
